import { Dayjs } from 'dayjs';
import { AggregatePeriod } from 'v2/core/entities';

const DAY_FORMAT = 'DD';
const MONTH_FORMAT_WITHOUT_YEAR = 'MMM';
const MONTH_FORMAT_WITH_YEAR = "MMM'YY";

interface GetFormattedTimeWindowPtions {
  startDate: Dayjs;
  endDate: Dayjs;
  aggregatePeriod: AggregatePeriod;
  firstTimeWindow?: Dayjs;
  lastTimeWindow?: Dayjs;
  customMonthYearFormat?: string;
}

export const getFormattedTimeWindow = ({
  startDate,
  endDate,
  aggregatePeriod,
  firstTimeWindow,
  lastTimeWindow,
  customMonthYearFormat,
}: GetFormattedTimeWindowPtions): string => {
  const isSameYear = firstTimeWindow?.isSame(lastTimeWindow, 'year') ?? true;
  const monthFormat =
    customMonthYearFormat ||
    (isSameYear ? MONTH_FORMAT_WITHOUT_YEAR : MONTH_FORMAT_WITH_YEAR);

  switch (aggregatePeriod) {
    case AggregatePeriod.MONTH:
      return startDate.format(monthFormat);

    case AggregatePeriod.WEEK:
      const isDateRangeInSameMonth = startDate.isSame(endDate, 'month');
      if (isDateRangeInSameMonth) {
        // '\n' for line break on UI
        return `${startDate.format(DAY_FORMAT)}-${endDate.format(
          DAY_FORMAT,
        )}\n${endDate.format(monthFormat)}`;
      }

      const isDateRangeInSameYear = startDate.isSame(endDate, 'year');
      // '\0' for additional formatting on UI, for ex. replace it with " - "
      return `${startDate.format(
        `${DAY_FORMAT} ${
          isDateRangeInSameYear ? MONTH_FORMAT_WITHOUT_YEAR : monthFormat
        }`,
      )}\n\0${endDate.format(`${DAY_FORMAT} ${monthFormat}`)}`;

    default:
      return startDate.format(`${DAY_FORMAT}\n${monthFormat}`);
  }
};
